export type BoxType = 'PHYSICAL' | 'VIRTUALBOX' | 'VMWARE' | 'HYPERV';

export function isVmBox(type?: BoxType | null): boolean {
  return type !== undefined && type !== null && type !== 'PHYSICAL';
}

export function isPhysicalBox(type?: BoxType | null): boolean {
  return type === 'PHYSICAL';
}

export function getBoxTypeLabel(
  type?: BoxType | null,
  translateService?: { instant: (key: string) => string },
): string {
  switch (type) {
    case 'PHYSICAL':
      return translateService ? translateService.instant('boxes.types.physical') : 'Physical';
    case 'VIRTUALBOX':
      return 'VirtualBox';
    case 'VMWARE':
      return 'VMware';
    case 'HYPERV':
      return 'Hyper-V';
    default:
      return translateService ? translateService.instant('boxes.types.unknown') : 'Unknown';
  }
}
